import React, { Component } from 'react';
import { Form, Button, Container, Row, Col, Alert } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import API from './API';

class ResetPassword extends Component {
    state = {
        password: '',
        confirmPassword: '',
        message: null,
        error: null,
        loading: false,
        success: false
    };

    handleChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    };

    handleSubmit = async (e) => {
        e.preventDefault();
        const { password, confirmPassword } = this.state;
        const { uid, token } = this.props.match.params;

        if (password !== confirmPassword) {
            this.setState({ error: 'パスワードが一致しません。' });
            return;
        }

        this.setState({ loading: true, message: null, error: null });

        try {
            await API.confirmPasswordReset(uid, token, password);
            this.setState({ message: 'パスワードが再設定されました。新しいパスワードでログインしてください。', loading: false, success: true });
        } catch (err) {
            this.setState({ error: '再設定に失敗しました。リンクの有効期限が切れている可能性があります。', loading: false });
        }
    };

    render() {
        const { password, confirmPassword, message, error, loading, success } = this.state;

        return (
            <Container>
                <Row className="justify-content-md-center">
                    <Col md={6}>
                        <div className="page-wrapper" style={{ marginTop: '50px' }}>
                            <h2 className="text-center mb-4">新しいパスワードの設定</h2>

                            {message && <Alert variant="success">{message}</Alert>}
                            {error && <Alert variant="danger">{error}</Alert>}

                            {!success ? (
                                <Form onSubmit={this.handleSubmit}>
                                    <Form.Group controlId="password">
                                        <Form.Label>新しいパスワード</Form.Label>
                                        <Form.Control
                                            type="password"
                                            name="password"
                                            placeholder="新しいパスワード"
                                            value={password}
                                            onChange={this.handleChange}
                                            required
                                        />
                                    </Form.Group>

                                    <Form.Group controlId="confirmPassword">
                                        <Form.Label>新しいパスワード（確認）</Form.Label>
                                        <Form.Control
                                            type="password"
                                            name="confirmPassword"
                                            placeholder="もう一度入力してください"
                                            value={confirmPassword}
                                            onChange={this.handleChange}
                                            required
                                        />
                                    </Form.Group>

                                    <Button variant="primary" type="submit" disabled={loading || !password} block>
                                        {loading ? '設定中...' : 'パスワードを設定'}
                                    </Button>
                                </Form>
                            ) : (
                                <div className="text-center mt-3">
                                    <Link to="/login" className="btn btn-primary btn-block">ログイン画面へ</Link>
                                </div>
                            )}
                        </div>
                    </Col>
                </Row>
            </Container>
        );
    }
}

export default ResetPassword;
